import React from 'react';
import { Link } from 'react-router-dom';
import './AppNav.css';

/**
 * The one place-switcher every page shares (nav concept "Option B"):
 * PLACES live here and never change — Inventory · Branches · Tasks — with the
 * current page highlighted instead of hidden. Page-specific ACTIONS (refresh,
 * admin, user) stay in each page's header, to the right of this nav.
 */
const PLACES = [
    {
        id: 'inventory', label: 'Inventory', to: '/',
        icon: (
            <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15" aria-hidden="true">
                <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
        ),
    },
    {
        id: 'branches', label: 'Branches', to: '/branches',
        icon: (
            <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15" aria-hidden="true">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v14a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
            </svg>
        ),
    },
    {
        id: 'tasks', label: 'Tasks', to: '/tasks',
        icon: (
            <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15" aria-hidden="true">
                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
        ),
    },
];

function AppNav({ current }) {
    return (
        <nav className="app-nav" aria-label="Main">
            {PLACES.map((p) => (
                <Link
                    key={p.id}
                    to={p.to}
                    className={`app-nav-item ${current === p.id ? 'app-nav-active' : ''}`}
                    aria-current={current === p.id ? 'page' : undefined}
                >
                    {p.icon}
                    {p.label}
                </Link>
            ))}
        </nav>
    );
}

export default AppNav;
